<template>
  <div :class="`flight-pad-endpoint flight-pad-endpoint__${alignment}`">
    <span :class="`flight-pad-endpoint__day ${date_classes}`">
      {{ parse_flight_offers_date(info.at).day_number }}
      {{ parse_flight_offers_date(info.at).month_string.slice(0, 3) }}.
    </span>
    <delta-overlay
      :text="parse_flight_offers_date(info.at).hour"
      :delta="delta"
      :classes="`flight-pad-endpoint__time ${
        highlight_time ? 'flight-pad-endpoint__time__highlight semibold' : ''
      }`"
      :delta_classes="`text-primary`"
    >
    </delta-overlay>
    <span
      v-if="!hide_location"
      class="flight-pad-endpoint__location"
      v-b-popover.hover.bottom="(locations[info.iataCode] || {}).name"
    >
      {{ info.iataCode }}
    </span>
  </div>
</template>

<script>
import { parse_flight_offers_date } from '@liveflight/utilities/dates';
import DeltaOverlay from '@liveflight/components/blocks/flight-pad/delta-overlay.vue';

export default {
  name: 'flight-pad-endpoint',
  components: {
    'delta-overlay': DeltaOverlay,
  },
  props: {
    info: Object,
    highlight_time: {
      type: Boolean,
      default: () => false,
    },
    hide_location: {
      type: Boolean,
      default: () => false,
    },
    date_classes: {
      type: String,
      default: () => '',
    },
    alignment: {
      type: String,
      default: () => 'center',
    },
    delta: {
      type: Number,
      default: () => 0,
    },
  },
  computed: {
    locations() {
      try {
        const dictionaries = this.$store.state.liveflight.results.dictionaries || {};
        return dictionaries.locations || {};
      } catch {
        return {};
      }
    },
  },
  methods: {
    parse_flight_offers_date,
  },
};
</script>

<style lang="scss" scoped>
.flight-pad-endpoint {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: normal;

  &__day {
    font-size: 12px;
  }
  &__time {
    font-size: 16px;
    &__highlight {
      font-size: 24px;
      @include media-breakpoint-down(md) {
        font-size: 18px;
      }
    }
  }

  &__location {
    font-size: 16px;
  }

  &__start {
    align-items: flex-start;
    &-reverse {
      align-items: flex-start;
      flex-direction: column-reverse;
      line-height: unset;
    }
  }
  &__center {
    align-items: center;
    &-reverse {
      align-items: center;
      flex-direction: column-reverse;
      line-height: unset;
    }
  }
  &__end {
    align-items: flex-end;
    &-reverse {
      align-items: flex-end;
      flex-direction: column-reverse;
      line-height: unset;
    }
  }

  @include media-breakpoint-down(md) {
    &__day {
      display: none;
    }
  }
}
</style>
